import { render, staticRenderFns } from "./OrderPageStats.vue?vue&type=template&id=6373957c&scoped=true"
import script from "./OrderPageStats.vue?vue&type=script&lang=js"
export * from "./OrderPageStats.vue?vue&type=script&lang=js"
import style0 from "./OrderPageStats.vue?vue&type=style&index=0&id=6373957c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373957c",
  null
  
)

export default component.exports